export const createGigyaPromise = (fn) => {
    return (params = {}) => new Promise((resolve) => {
        const gigyaFn = fn();
        gigyaFn({
            ...params,
            callback: function (response) {
                resolve(response);
            },
        });
    });
};
//# sourceMappingURL=create-gigya-promise.js.map